export const fulfillmentStatus = {
    GOOD: {
        value: 'GOOD',
        text: 'good',
    },
    DELAY: {
        value: 'DELAY',
        text: 'delay',
    },
    STOP: {
        value: 'STOP',
        text: 'stop',
    },
};
